import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useHistory } from "react-router-dom";
import {
    Typography, Spin, Card,
    Layout,
    Row,
    Col,
    Tag,
    Button,
    List,
    Divider,
    Input
} from 'antd';
import SidebarLayoutConsumer from "../Administrator/SidebarLayoutConsumer";
import {
    ArrowLeftOutlined,
    DownloadOutlined
} from "@ant-design/icons";
import { routes } from "../../../routes/Routes";
import CustomModal from '../../../components/Modal/Modal';

const { Content, Sider } = Layout;
const { Title, Text, Paragraph } = Typography;
const { TextArea } = Input;


const ConsumerSecondaryMarketDetail = () => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const [expressInterestModalVisible, setExpressInterestModalVisible] = useState(false);  
    const [saveForLaterModalVisible, setSaveForLaterModalVisible] = useState(false);
    const [contactTeamModalVisible, setContactTeamModalVisible] = useState(false);
    const [contactMessageValue, setContactMessageValue] = useState('');
    const [contactMessageModalFlag, setContactMessageModalFlag] = useState(false);
    const [charCount, setCharCount] = useState(0);
    const [validationError, setValidationError] = useState('');

    useEffect(() => {
        setLoading(false);
    }, []);

    const { fundId } = useParams();


    const [data, setData] = useState(null);
    const getFundDetails = async (fundId) => {
        // Example:
        // return axios.get(`/api/funds/${fundId}`);

        return {
            id: fundId,
            name: "Sequoia Capital Fund XVI",
            manager: "Sequoia Capital",
            assetClass: "Venture Capital",
            vintage: 2021,
            status: "Active",

            summary: {
                interestSize: "$125M",
                nav: "$142M",
                irr: 18.2,
                moic: "1.14x",
                valuationDate: "Q3 2023"
            },

            performance: {
                dpi: "0.23x",
                rvpi: "0.91x",
                fundSize: "$2.8B",
                capitalCalled: "$118M",
                distributed: "$29M",
                remainingValue: "$113M"
            },

            portfolio: [
                { name: "Strip", secondaryName: "Fintech", value: "$18M" },
                { name: "Discord", secondaryName: "Consumer", value: "$12M" },
                { name: "Databricks", secondaryName: "Enterprise", value: "$11M" },
                { name: "Instacart", secondaryName: "Consumer", value: "$9M" },
                { name: "Others", secondaryName: "Various", value: "$82M" }
            ],

            details: {
                strategy:
                    "Early growth-stage investments in technology companies across consumer, enterprise, healthcare, and fintech sectors.",
                geography: "US (70%), Europe (20%), Asia (10%)",
                auditor: "PWC",
                administrator: "SS&C"
            },

            documents: [
                { name: "Q3 2023 Quarterly Report", secondaryName: "Report • 2025-10-15" },
                { name: "Audited Financial Statements 2024", secondaryName: "Report • 2025-03-31" },
                { name: "Limited Partnership Agreement", secondaryName: "Legal • 2021-06-01" },
                { name: "K-1 Tax Form 2024", secondaryName: "Tax • 2025-03-15" }
            ]
        };
    };
    useEffect(() => {
        getFundDetails(fundId)
            .then(setData)
            .finally(() => setLoading(false));
    }, [fundId]);
    const pageStyles = {
        layout: {
            padding: 24,
            background: "#0b0c0d"
        },
        sider: {
            background: "transparent",
            paddingLeft: 12
        }
    };

    if (loading || !data) {
        return (
            <div style={{ textAlign: "center", padding: 80 }}>
                <Spin size="large" />
            </div>
        );
    }
    const onBack = () => {
        history.push(routes.consumerMarketPlace.path);
    }



  const handleContactMessageChange = (e) => {
    const value = e.target.value;
    if (value.length <= 500) {
      setContactMessageValue(value);
      setCharCount(value.length);
      setValidationError('');
    } else {
      setValidationError('Message cannot exceed 500 characters');
    }
  };

  const handleSubmitContactMessage = () => {
    if (contactMessageValue.trim().length === 0) {
      setValidationError('Please enter a message');
      return;
    }
    if (contactMessageValue.length > 500) {
      setValidationError('Message cannot exceed 500 characters');
      return;
    }
    // Close the input modal and open success modal
    setContactMessageModalFlag(false);
    setContactTeamModalVisible(true);
    setContactMessageValue('');
    setCharCount(0);
    setValidationError('');
  };

  const handleCancelContactMessage = () => {
    setContactMessageModalFlag(false);
    setContactMessageValue('');
    setCharCount(0);
    setValidationError('');
  };

    return (
        <>
            <Spin spinning={loading}>
                <SidebarLayoutConsumer>
                    <div className="secondary-market-details">
                    <Card className="top-card cardViewMain">
                            <Button
                                type="link"
                                icon={<ArrowLeftOutlined />}
                                onClick={onBack}
                            >
                                Back to Marketplace
                            </Button>
                        </Card>
                    <Layout style={pageStyles.layout} className="secondaryDetailMain">
                        
                        <Content>

                            {/* Back */}
                            

                            {/* Header */}
                            <Card className="cardViewMain">
                                <Row justify="space-between">
                                    <Col className="title-col">
                                        <Title level={3}>{data.name}</Title>
                                        <Text type="secondary">
                                            {data.manager}
                                        </Text>
                                         <Text type="secondary" className="secondary-sub-title">
                                            <img className="icon" src={`${process.env.PUBLIC_URL}/building.svg`} alt="Building" /> <span className="text" >{data.assetClass}</span> <span className="dot">•</span> 
                                            <img className="icon" src={`${process.env.PUBLIC_URL}/calender.svg`} alt="Calendar" /> <span className="text" >{data.vintage} </span> 
                                        </Text>
                                    </Col>
                                    <Col>
                                        <Tag className="status-tag">{data.status}</Tag>
                                    </Col>
                                </Row>
                            </Card>

                            <Row gutter={[8, 8]} className="card-gird-row">
                                    {[
                                        ["Interest Size", data.summary.interestSize],
                                        ["Current NAV", data.summary.nav],
                                        ["IRR", `+${data.summary.irr}%`],
                                        ["MOIC", data.summary.moic]
                                    ].map(([label, value]) => (
                                        <Col xs={12} md={6} key={label}>
                                            <Card className="cardViewMain" size="small">
                                                <Text type="secondary">{label}</Text>
                                                <Title level={5}>{value}</Title>
                                            </Card>
                                        </Col>
                                    ))}
                            </Row>

                            {/* Performance */}
                            <Card className="cardViewMain card-div" title={<><img src={`${process.env.PUBLIC_URL}/graph.svg`} alt="Performance Metrics" /> Performance Metrics</>}>
                                <Row gutter={16}>
                                    {Object.entries(data.performance).map(([key, value]) => (
                                        <Col xs={12} md={8} key={key}>
                                            <Text type="secondary" className="sub-text">{key.toUpperCase()}</Text>
                                            <Title level={5}>{value}</Title>
                                        </Col>
                                    ))}
                                </Row>
                            </Card>

                            {/* Portfolio */}
                            <Card className="cardViewMain card-div" title={<div style={{ display:"grid" }}><div style={{ display: "flex", gap:"4px" , marginBottom:"16px"}}><img src={`${process.env.PUBLIC_URL}/chart.svg`} alt="Fund Details" />Portfolio Composition</div><Text type="secondary" className="sub-text">{"42 Portfolio Companies"}</Text></div>}>
                                
                                <List
                                    dataSource={data.portfolio}
                                    renderItem={(item,index) => (
                                        <List.Item>
                                            <div style={{ display: "grid" }}>
                                                <Text className="name">{item.name}</Text>
                                                <Text className="secondary-name">{item.secondaryName}</Text>
                                            </div>
                                            
                                            <Text className="value">{item.value}</Text>
                                            {/* {index !== data.portfolio.length -1 && <Divider />} */}
                                        </List.Item>
                                    )}
                                />
                            </Card>

                            {/* Fund Details */}
                            <Card className="cardViewMain card-div" title={<><img src={`${process.env.PUBLIC_URL}/user-grp.svg`} alt="Fund Details" /> Fund Details</>}>
                                <Text type="secondary" className="sub-text">Investment Strategy</Text>
                                <Paragraph className="paragraph-text">{data.details.strategy}</Paragraph>
                                <Text type="secondary" className="sub-text">Geographic Focus</Text>
                                <Paragraph className="paragraph-text">United States (70%), Europe (20%), Asia (10%)</Paragraph>

                                <Row gutter={16} className="colorWhite">
                                    <Col span={12}>
                                        <Text type="secondary" className="sub-text">Auditor</Text>
                                        <Paragraph className="paragraph-text">{data.details.auditor}</Paragraph>
                                    </Col>
                                    <Col span={12}>
                                        <Text type="secondary" className="sub-text">Administrator</Text>
                                        <Paragraph className="paragraph-text">{data.details.administrator}</Paragraph>
                                    </Col>
                                </Row>
                            </Card>

                            {/* Documents */}
                            <Card className="cardViewMain  card-div documentList" title={ <><img src={`${process.env.PUBLIC_URL}/document-icon.svg`} alt="Documents" /> Documents</>}>
                                <List
                                    dataSource={data.documents}
                                    renderItem={(doc) => (
                                        <List.Item
                                            className="cardViewMain"
                                            actions={[
                                                <Button
                                                    type="link"
                                                    // icon={<DownloadOutlined />}
                                                >
                                                    <DownloadOutlined />
                                                    {/* Download */}
                                                </Button>
                                            ]}
                                        >
                                            <img src={`${process.env.PUBLIC_URL}/document-icon.svg`} style={{ marginRight: "8px" }} alt="Documents" />
                                            <div style={{ display: "grid" }}>
                                                <Text className="name">{doc.name}</Text>
                                                <Text className="secondary-name">{doc.secondaryName}</Text>
                                            </div>
                                        </List.Item>
                                    )}
                                />
                            </Card>
                        </Content>

                        {/* Sidebar */}
                        <div style={{ width: 384, ...pageStyles.sider }} className="side-bar">
                            <Card className="cardViewMain" title="Express Interest">
                                <Text type="secondary" className="title">Interest Size</Text>
                                <Title level={5} className="sub-title">{data.summary.interestSize}</Title>

                                <Text type="secondary" className="title">Current NAV</Text>
                                <Title level={5} className="sub-title">{data.summary.nav}</Title>

                                <Text type="secondary" className="title">Valuation Date</Text>
                                <div className="colorWhite">{data.summary.valuationDate}</div>

                                <Button type="primary" className="express-interest" onClick={() => setExpressInterestModalVisible(true)}>
                                    Express Interest
                                </Button>

                                <Button block className="save-later" style={{ marginTop: 8 }} onClick={() => setSaveForLaterModalVisible(true)}>
                                    Save for Later
                                </Button>

                                <div className="info">
                                    <Text type="secondary" className="title">Need more information?</Text>
                                    <Title level={5} className="sub-title" style={{ cursor: 'pointer' }} onClick={() => setContactMessageModalFlag(true)} >Contact our team →</Title>
                                </div>

                                <Paragraph type="primary" className="note" style={{ marginTop: 16 }}>
                                    All transactions are subject to KYC/AML verification and
regulatory approval. Past performance does not guarantee
future results.
                                </Paragraph>
                            </Card>
                        </div>
                    </Layout>
                    </div>
                    {/* Success Modal */}
      <CustomModal
        visible={expressInterestModalVisible}
        onClose={() => setExpressInterestModalVisible(false)}
        onPrimaryAction={() => {
        //   console.log('Primary action');
          setExpressInterestModalVisible(false);
        }}
        primaryButtonText="OK"
        secondaryButtonText=""
        title="Thank you for expressing interest!"
        description="A Levridge representative will be in contact with you within the next 24 hours."
        status=""
      />
      <CustomModal
                        visible={saveForLaterModalVisible}
                        onClose={() => setSaveForLaterModalVisible(false)}
                        onPrimaryAction={() => {
                            setSaveForLaterModalVisible(false);
                        }}
                        primaryButtonText="OK"
                        showSecondaryButton={false}
                        title="Watch List!"
                        description="Watch List updated."
                    />



        <CustomModal
          visible={contactMessageModalFlag}
          onClose={handleCancelContactMessage}
          onPrimaryAction={handleSubmitContactMessage}
          onSecondaryAction={handleCancelContactMessage}
          primaryButtonText="Submit"
          secondaryButtonText="Cancel"
          showSecondaryButton={true}
          title="Contact Support"
          description="Message:"
          showTextarea={true}
        >
          <TextArea
            value={contactMessageValue}
            onChange={handleContactMessageChange}
            placeholder="Enter your message here..."
            rows={4}
            maxLength={500}
            style={{ marginTop: 16, marginBottom: 8 }}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text type={"secondary"} style={{ fontSize: 12 }}>
              {`${charCount}/500 characters`}
            </Text>
          </div>
          {validationError && (
            <div style={{ color: '#ff4d4f', marginTop: 4, fontSize: 12 }}>
              {validationError}
            </div>
          )}
        </CustomModal>

                    <CustomModal
                        visible={contactTeamModalVisible}
                        onClose={() => setContactTeamModalVisible(false)}
                        onPrimaryAction={() => {
                            setContactTeamModalVisible(false);
                        }}
                        primaryButtonText="OK"
                        showSecondaryButton={false}
                        title="Thank you for your submission."
                        description="A Levridge representative will be in contact with you within the next 24 hours."
                    />
                </SidebarLayoutConsumer >
            </Spin >
        </>
    )
}
export default ConsumerSecondaryMarketDetail